<template>
	<side-window :tabs="tabs" :active="active" class="contact" title="E-mail" @pop="$emit('pop')" @close="$emit('close')" @tabSelect="tabSelect">
		<div v-if="!id || (form && id)">
			<form-grid-layout>
				<div v-show="active == 'details'">
					<sender-employee-select-view v-model="entity" label="Afsender" :optional="true" />
					<string-view label="Modtager" v-model="entity.email_recipient" />
					<string-view label="Kopi til" v-model="email_copy" :optional="true" />
					<text-view label="Besked" v-model="entity.email_message" :height="300" @dblclick.native="copy" />
				</div>
				<div v-show="active == 'details'">
					<div class="side-window__heading">
						Vedhæft automatisk udskrift
						<switch-view v-model="entity.auto_gen" />
					</div>
				</div>
				<div v-show="active == 'details'">
					<file-list-view v-model="attachments" />
				</div>
			</form-grid-layout>
		</div>
		<div slot="footer">
			<button-view label="Send" @click="onAddButtonClick" />
		</div>
	</side-window>
</template>

<script>
	import TextView from '../views/TextView';
	import StringView from '../views/StringView';
	import FileListView from '../views/FileListView';
	import RouteView from '../views/RouteView';
	import RequirementsView from '../views/RequirementsView';
	import PhotosView from '../views/PhotosView';
	import InstructionsView from '../views/InstructionsView';
	import PackagingView from '../views/PackagingView';
	import OrderView from '../views/OrderView';
	import ContactSelectView from '../views/ContactSelectView';
	import EmployeeSelectView from '../views/EmployeeSelectView';
	import SenderEmployeeSelectView from '../views/SenderEmployeeSelectView';
	import TaskListView from '../views/TaskListView';

	import LeadModel from '../model/Lead'

	import merge from '../functions/merge'

	export default {
		data: function () {
			return {
				//packaging: [],
				//ORDER: [],
				active: 'details',
				attachments: [],
				email_copy: ''
				//files: [],
				//instructions: [],
				//departments: [],
				//motivations: [],
				//tasks: []
			};
		},
		watch: {
			from(newVal) {
				this.to = newVal;
			}
		},
		components: {
			'TextView': TextView,
			'StringView': StringView,
			'FileListView': FileListView,
			'RouteView': RouteView,
			'RequirementsView': RequirementsView,
			'PhotosView': PhotosView,
			'InstructionsView': InstructionsView,
			'PackagingView': PackagingView,
			'OrderView': OrderView,
			'ContactSelectView': ContactSelectView,
			'TaskListView': TaskListView,
			'EmployeeSelectView': EmployeeSelectView,
			'SenderEmployeeSelectView': SenderEmployeeSelectView
		},
		computed: {
			tabs: function () {
				return [
					{
						name: 'details',
						label: 'Besked'
					}
				];
			}
		},
		props: {
			id: Number,
			form: Boolean,
			submit: {
				type: Function,
				default: function (entity) { return true; }
			},
			entity: {
				type: Object,
				default() {
					return merge({}, {
						email_recipient: '',
						email_message: '',
						auto_gen: false,
						files: []
					});
				}
			}
		},
		methods: {
			tabSelect(name, tabName) {
				
				this.active = tabName;
			},
			onAddButtonClick() {
				if (this.entity.email_recipient.toString().trim() != this.entity.email_recipient.toString()) {
					alert('Du har mellemrum i e-mail, enten før eller efter');
					return;
				}

				
				this.submit(merge({
					attachments: this.attachments,
					email_copy: this.email_copy
				}, this.entity));
			},
			copy() {
				
				//var value = merge({}, this.entity);
				this.entity.email_message = this.entity.description;
				//this.$emit('input', value);
			}
		},
		mounted: function() {
			
			

			var self = this;

			

			//this.entity.email_recipient = this.entity.customer.email;




			/*this.axios
				.get('/us/departments/')
				.then(function (r) {
					self.departments = r.data._items;
					//self.entity.roles = {...self._roles, ...self.entity.roles};
				});*/

		}
	}
</script>

<style lang="scss">
	
</style>
